import App from './App';

const Perms = _ => {
    const perm = App.storage.get('redux', {})?.user?.permissions || [];
    const bc = window.ENV.BASIC_CONFIGURATION || false;

    return {
        DASHBOARD: {
            SHOW_BLOOD_BANK_INVENTORY: bc || perm?.DASHBOARD?.SHOW_BLOOD_BANK_INVENTORY,
            // اگر در حالت تنظیمات اولیه باشیم کاربر اجازه دسترسی به صفحه داشبورد مدیریت رو نداره
            SHOW_MINISTRY: window.ENV.BASIC_CONFIGURATION ? false : perm?.DASHBOARD?.SHOW_MINISTRY,
            TRACK_PRODUCT: bc || perm?.DASHBOARD?.TRACK_PRODUCT
        },
        BLOOD_BANK_INCOMING: {
            VIEW: bc || perm?.BLOOD_BANK_INCOMING?.VIEW,
            INSERT: bc || perm?.BLOOD_BANK_INCOMING?.INSERT,
            UPDATE: bc || perm?.BLOOD_BANK_INCOMING?.UPDATE,
            DELETE: bc || perm?.BLOOD_BANK_INCOMING?.DELETE,
            DESTROY: bc || perm?.BLOOD_BANK_INCOMING?.DESTROY,
            RETRIEVE_TO_ORG: bc || perm?.BLOOD_BANK_INCOMING?.RETRIEVE_TO_ORG
        },
        BLOOD_BANK_OUTGOING: {
            VIEW: bc || perm?.BLOOD_BANK_OUTGOING?.VIEW,
            CANCEL: bc || perm?.BLOOD_BANK_OUTGOING?.CANCEL,
            RETRIEVE_TO_BLOOD_BANK: bc || perm?.BLOOD_BANK_OUTGOING?.RETRIEVE_TO_BLOOD_BANK
        },
        BLOOD_BANK_NORM_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.REJECT_AWAITING,
                SET_BLOOD_GROUP: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.SET_BLOOD_GROUP_AWAITING,
            },
            CROSS_MATCH_OR_SENT: {
                VIEW: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_CROSS_MATCH_OR_SENT,
                CROSS_MATCH: bc || (perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_CROSS_MATCH_OR_SENT && perm?.BLOOD_BANK_NORM_REQUESTS?.CROSS_MATCH),
                CANCEL_CROSS_MATCH: bc || (perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_CROSS_MATCH_OR_SENT && perm?.BLOOD_BANK_NORM_REQUESTS?.CANCEL_CROSS_MATCH),
                DELIVERY: bc || (perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_CROSS_MATCH_OR_SENT && perm?.BLOOD_BANK_NORM_REQUESTS?.DELIVERY)
            },
            RESERVE: {
                VIEW: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_RESERVES,
                INSERT: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.RESERVE,
                CANCEL: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.CANCEL_RESERVE,
            },
            INCOMPATIBLE: {
                VIEW: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.VIEW_INCOMPATIBLES,
                INSERT: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.INSERT_INCOMPATIBLE,
                DELETE: bc || perm?.BLOOD_BANK_NORM_REQUESTS?.DELETE_INCOMPATIBLE
            }
        },
        BLOOD_BANK_EMER_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.REJECT_AWAITING,
                SET_BLOOD_GROUP: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.SET_BLOOD_GROUP_AWAITING,
            },
            CROSS_MATCH_OR_SENT: {
                VIEW: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.VIEW_CROSS_MATCH_OR_SENT,
                CROSS_MATCH: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.CROSS_MATCH,
                CANCEL_CROSS_MATCH: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.CANCEL_CROSS_MATCH,
                DELIVERY: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.DELIVERY,
            },
            RESERVE: {
                VIEW: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.VIEW_RESERVES,
                INSERT: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.RESERVE,
                CANCEL: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.CANCEL_RESERVE,
            },
            INCOMPATIBLE: {
                VIEW: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.VIEW_INCOMPATIBLES,
                INSERT: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.INSERT_INCOMPATIBLE,
                DELETE: bc || perm?.BLOOD_BANK_EMER_REQUESTS?.DELETE_INCOMPATIBLE
            }
        },
        ORG_NORM_REQUESTS: {
            VIEW: bc || perm?.ORG_NORM_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.ORG_NORM_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.ORG_NORM_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.ORG_NORM_REQUESTS?.REJECT_AWAITING,
            },
                ADD_PRODUCT: bc || perm?.ORG_NORM_REQUESTS?.ADD_PRODUCT_TO_REQUEST,
                DELIVERY: bc || perm?.ORG_NORM_REQUESTS?.DELIVERY_REQUEST_TO_HOSPITAL
        },
        ORG_EMER_REQUESTS: {
            VIEW: bc || perm?.ORG_EMER_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.ORG_EMER_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.ORG_EMER_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.ORG_EMER_REQUESTS?.REJECT_AWAITING,
            },
            ADD_PRODUCT: bc || perm?.ORG_NORM_REQUESTS?.ADD_PRODUCT_TO_REQUEST,
            DELIVERY: bc || perm?.ORG_NORM_REQUESTS?.DELIVERY_REQUEST_TO_HOSPITAL
        },
        ORG_WASH_REQUESTS: {
            VIEW: bc || perm?.ORG_WASH_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.ORG_WASH_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.ORG_WASH_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.ORG_WASH_REQUESTS?.REJECT_AWAITING,
            },
            DELIVERY: bc || perm?.ORG_WASH_REQUESTS?.DELIVERY_REQUEST_TO_HOSPITAL
        },
        ORG_IRRADIATE_REQUESTS: {
            VIEW: bc || perm?.ORG_IRRADIATE_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.ORG_IRRADIATE_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.ORG_IRRADIATE_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.ORG_IRRADIATE_REQUESTS?.REJECT_AWAITING,
            },
            DELIVERY: bc || perm?.ORG_IRRADIATE_REQUESTS?.DELIVERY_REQUEST_TO_HOSPITAL
        },
        SECTION_NORM_REQUESTS: {
            VIEW: bc || perm?.SECTION_NORM_REQUESTS?.VIEW,
            INSERT: bc || perm?.SECTION_NORM_REQUESTS?.INSERT,
            UPDATE: bc || perm?.SECTION_NORM_REQUESTS?.UPDATE,
            DELETE: bc || perm?.SECTION_NORM_REQUESTS?.DELETE
        },
        SECTION_EMER_REQUESTS: {
            VIEW: bc || perm?.SECTION_EMER_REQUESTS?.VIEW,
            INSERT: bc || perm?.SECTION_EMER_REQUESTS?.INSERT,
            UPDATE: bc || perm?.SECTION_EMER_REQUESTS?.UPDATE,
            DELETE: bc || perm?.SECTION_EMER_REQUESTS?.DELETE
        },
        SECTION_ORG_EMER_REQUESTS: {
            VIEW: bc || perm?.SECTION_ORG_EMER_REQUESTS?.VIEW,
            INSERT: bc || perm?.SECTION_ORG_EMER_REQUESTS?.INSERT,
            UPDATE: bc || perm?.SECTION_ORG_EMER_REQUESTS?.UPDATE,
            DELETE: bc || perm?.SECTION_ORG_EMER_REQUESTS?.DELETE
        },
        SECTION_WASH_REQUESTS: {
            VIEW: bc || perm?.SECTION_WASH_REQUESTS?.VIEW,
            INSERT: bc || perm?.SECTION_WASH_REQUESTS?.INSERT,
            UPDATE: bc || perm?.SECTION_WASH_REQUESTS?.UPDATE,
            DELETE: bc || perm?.SECTION_WASH_REQUESTS?.DELETE
        },
        SECTION_IRRADIATE_REQUESTS: {
            VIEW: bc || perm?.SECTION_IRRADIATE_REQUESTS?.VIEW,
            INSERT: bc || perm?.SECTION_IRRADIATE_REQUESTS?.INSERT,
            UPDATE: bc || perm?.SECTION_IRRADIATE_REQUESTS?.UPDATE,
            DELETE: bc || perm?.SECTION_IRRADIATE_REQUESTS?.DELETE
        },
        BLOOD_BANK_ORG_NORM_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_ORG_NORM_REQUESTS?.VIEW,
            INSERT: bc || perm?.BLOOD_BANK_ORG_NORM_REQUESTS?.INSERT,
            UPDATE: bc || perm?.BLOOD_BANK_ORG_NORM_REQUESTS?.UPDATE,
            DELETE: bc || perm?.BLOOD_BANK_ORG_NORM_REQUESTS?.DELETE
        },
        BLOOD_BANK_ORG_EMER_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.REJECT_AWAITING,
            },
            UPDATE: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.UPDATE,
            DELETE: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.DELETE,
            SENT_TO_ORG: bc || perm?.BLOOD_BANK_ORG_EMER_REQUESTS?.SENT_TO_ORG
        },
        BLOOD_BANK_WASH_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.REJECT_AWAITING,
            },
            DELETE: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.DELETE,
            ADD_PRODUCT: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.ADD_PRODUCT,
            REMOVE_PRODUCT: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.REMOVE_PRODUCT,
            SENT_TO_ORG: bc || perm?.BLOOD_BANK_WASH_REQUESTS?.SENT_TO_ORG
        },
        BLOOD_BANK_IRRADIATE_REQUESTS: {
            VIEW: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.VIEW,
            AWAITING: {
                VIEW: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.VIEW_AWAITING,
                CONFIRM: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.CONFIRM_AWAITING,
                REJECT: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.REJECT_AWAITING,
            },
            DELETE: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.DELETE,
            ADD_PRODUCT: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.ADD_PRODUCT,
            REMOVE_PRODUCT: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.REMOVE_PRODUCT,
            SENT_TO_ORG: bc || perm?.BLOOD_BANK_IRRADIATE_REQUESTS?.SENT_TO_ORG
        },
        SECTION_COMPLICATIONS: {
            VIEW: bc || perm?.SECTION_COMPLICATIONS?.VIEW,
            INSERT: bc || perm?.SECTION_COMPLICATIONS?.INSERT,
            UPDATE: bc || perm?.SECTION_COMPLICATIONS?.UPDATE,
            DELETE: bc || perm?.SECTION_COMPLICATIONS?.DELETE
        },
        ORG_COMPLICATIONS: {
            VIEW: bc || perm?.ORG_COMPLICATIONS?.VIEW
        },
        PATIENTS: {
            VIEW: bc || perm?.PATIENTS?.VIEW,
            UPDATE: bc || perm?.PATIENTS?.UPDATE,
            ACTIVATE_DEACTIVATE: bc || perm?.PATIENTS?.ACTIVATE_DEACTIVATE
        },
        REPORTS: {
            VIEW_READY_PRODUCTS: bc || perm?.REPORTS?.VIEW_READY_PRODUCTS,
            VIEW_RESERVED_PRODUCTS: bc || perm?.REPORTS?.VIEW_RESERVED_PRODUCTS,
            VIEW_RESERVE_LOGS: bc || perm?.REPORTS?.VIEW_RESERVE_LOGS,
            VIEW_DESTROYED_PRODUCTS: bc || perm?.REPORTS?.VIEW_DESTROYED_PRODUCTS,
            VIEW_SECTION_RETRIEVED_PRODUCTS: bc || perm?.REPORTS?.VIEW_SECTION_RETRIEVED_PRODUCTS,
            VIEW_BLOOD_BANK_RETRIEVED_PRODUCTS: bc || perm?.REPORTS?.VIEW_BLOOD_BANK_RETRIEVED_PRODUCTS
        },
        CONFIGURATION: {
            ROLES: {
                VIEW: bc || perm?.CONFIGURATION_ROLES?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_ROLES?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_ROLES?.UPDATE
            },
            RULES: {
                VIEW: bc || perm?.CONFIGURATION_RULES?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_RULES?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_RULES?.UPDATE,
                DELETE: bc || perm?.CONFIGURATION_RULES?.DELETE
            },
            HOSPITALS: {
                VIEW: bc || perm?.CONFIGURATION_HOSPITALS?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_HOSPITALS?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_HOSPITALS?.UPDATE,
                ACTIVATE_DEACTIVATE: bc || perm?.CONFIGURATION_HOSPITALS?.ACTIVATE_DEACTIVATE
            },
            SECTIONS: {
                VIEW: bc || perm?.CONFIGURATION_SECTIONS?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_SECTIONS?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_SECTIONS?.UPDATE,
                ACTIVATE_DEACTIVATE: bc || perm?.CONFIGURATION_SECTIONS?.ACTIVATE_DEACTIVATE
            },
            USERS: {
                VIEW: bc || perm?.CONFIGURATION_USERS?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_USERS?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_USERS?.UPDATE,
                ACTIVATE_DEACTIVATE: bc || perm?.CONFIGURATION_USERS?.ACTIVATE_DEACTIVATE
            },
            //todo enable all permission checks
            DOCTORS: {
                VIEW: bc || perm?.CONFIGURATION_DOCTORS?.VIEW,
                INSERT: bc || perm?.CONFIGURATION_DOCTORS?.INSERT,
                UPDATE: bc || perm?.CONFIGURATION_DOCTORS?.UPDATE,
                ACTIVATE_DEACTIVATE: bc || perm?.CONFIGURATION_DOCTORS?.ACTIVATE_DEACTIVATE
            }
        },
        SETTINGS: {
            VIEW: bc || perm?.SETTINGS?.VIEW
        }
    };
};

export default Perms;